// extracted by mini-css-extract-plugin
export default {"options":"Options_options__sIQ9O","option":"Options_option__UvVgf"};